import {
    ADD_FAVOURITE_PROJECT_PRIORITY,
    FETCH_ALL_PROJECT_PRIORITY_SUCCESS,
    FETCH_PROJECT_PRIORITY_SUCCESS,
    FILTER_PROJECT_PRIORITY,
    GET_ALL_PROJECT_PRIORITY,
    GET_UNSELECTED_ALL_PROJECT_PRIORITY,
    HANDLE_PROJECT_PRIORITY_REQUEST_CLOSE,
    HIDE_PROJECT_PRIORITY_LOADER,
    SHOW_PROJECT_PRIORITY_LOADER,
    ON_ADD_PROJECT_PRIORITY,
    ON_ALL_PROJECT_PRIORITY_SELECT,
    ON_PROJECT_PRIORITY_CLOSE,
    ON_PROJECT_PRIORITY_SELECT,
    ON_DELETE_PROJECT_PRIORITY_SUCCESS,
    ON_DELETE_SELECTED_PROJECT_PRIORITY,
    ON_FILTER_PROJECT_PRIORITY_OPTION_SELECT,
    ON_SAVE_PROJECT_PRIORITY_SUCCESS,
    ON_TOGGLE_PROJECT_PRIORITY_DRAWER,
    SHOW_PROJECT_PRIORITY_MESSAGE,
    UPDATE_SEARCH_PROJECT_PRIORITY,
    ON_PROJECT_COST_PRIORITIES_DASHBOARD,
    ON_PROJECT_BUSINESS_PRIORITIES_DASHBOARD,
    ON_GLOBAL_PROJECT_COST_PRIORITIES_DASHBOARD,
    ON_GLOBAL_PROJECT_BUSINESS_PRIORITIES_DASHBOARD,
    CLEAR_SESSION,
    CLEAR_SELECTED_OBJECTS,
} from 'constants/ActionTypes';

export const ALL_FILTER = 'All project prioritys';
export const STARRED_FILTER = 'Starred project prioritys';

export const INIT_STATE = {
    alertMessage: '',
    showMessage: false,
    loader: false,
    noContentFoundMessage: 'No project priorities found in selected folder',
    selectedSectionId: 1,
    drawerState: false,
    filterOption: ALL_FILTER,
    allProjectPriority: [],
    projectPriorityList: [],
    updatingProjectCostPriorities: false,
    updatingProjectBusinessPriorities: false,
    selectedProjectPriority: null,
    selectedProjectPrioritys: 0,
    addProjectPriorityState: false,
    searchProjectPriority: '',
    updatingGlobalPriorities: false,
    projectPriority: {
        name: 'ACME Inc',
        email: 'road.runner@example.com',
        avatar: 'assets/images/priorities-150_150.jpg',
    },
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case CLEAR_SESSION: {
            return {
                ...INIT_STATE,
            };
        }
        case CLEAR_SELECTED_OBJECTS: {
            return {
                ...state,
                selectedProjectPriority: null,
            };
        }
        case ON_PROJECT_COST_PRIORITIES_DASHBOARD: {
            return {
                ...state,
                loader: false,
                projectPriorityList: action.payload?.costImplPriorityParams || [],
                allProjectPriority: action.payload?.costImplPriorityParams || [],
                updatingProjectCostPriorities: true,
                updatingProjectBusinessPriorities: false,
                updatingGlobalPriorities: false,
                projectPriority: { ...state.projectPriority, name: action.payload?.name },
            };
        }
        case ON_PROJECT_BUSINESS_PRIORITIES_DASHBOARD: {
            return {
                ...state,
                loader: false,
                projectPriorityList: action.payload?.busValPriorityParams || [],
                allProjectPriority: action.payload?.busValPriorityParams || [],
                updatingProjectCostPriorities: false,
                updatingProjectBusinessPriorities: true,
                updatingGlobalPriorities: false,
                projectPriority: { ...state.projectPriority, name: action.payload?.name },
            };
        }
        case ON_GLOBAL_PROJECT_COST_PRIORITIES_DASHBOARD: {
            return {
                ...state,
                loader: false,
                projectPriorityList: action.payload || [],
                allProjectPriority: action.payload || [],
                updatingProjectCostPriorities: true,
                updatingProjectBusinessPriorities: false,
                updatingGlobalPriorities: true,
                projectPriority: { ...state.projectPriority, name: action.payload?.name },
            };
        }
        case ON_GLOBAL_PROJECT_BUSINESS_PRIORITIES_DASHBOARD: {
            return {
                ...state,
                loader: false,
                projectPriorityList: action.payload || [],
                allProjectPriority: action.payload?.busValPriorityParams || [],
                updatingProjectCostPriorities: false,
                updatingProjectBusinessPriorities: true,
                updatingGlobalPriorities: true,
                projectPriority: { ...state.projectPriority, name: action.payload?.name },
            };
        }
        case ADD_FAVOURITE_PROJECT_PRIORITY: {
            return {
                ...state,
                alertMessage: action.payload.starred ? 'Project priority removed as star' : 'Project priority marked as star',
                showMessage: true,
                projectPriorityList: state.projectPriorityList.map((projectPriority) =>
                    projectPriority.id === action.payload.id
                        ? {
                              ...projectPriority,
                              starred: !action.payload.starred,
                          }
                        : projectPriority
                ),
                allProjectPriority: state.allProjectPriority.map((projectPriority) =>
                    projectPriority.id === action.payload.id
                        ? {
                              ...projectPriority,
                              starred: !action.payload.starred,
                          }
                        : projectPriority
                ),
            };
        }
        case FETCH_PROJECT_PRIORITY_SUCCESS: {
            return {
                ...state,
                loader: false,
                selectedProjectPriority: action.payload,
            };
        }
        case FETCH_ALL_PROJECT_PRIORITY_SUCCESS: {
            return {
                ...state,
                loader: false,
                allProjectPriority: action.payload,
                projectPriorityList: action.payload,
                selectedSectionId: 1,
                searchProject: '',
                filterOption: ALL_FILTER,
            };
        }
        case SHOW_PROJECT_PRIORITY_MESSAGE: {
            return {
                ...state,
                alertMessage: action.payload,
                showMessage: true,
                loader: false,
            };
        }
        case ON_PROJECT_PRIORITY_SELECT: {
            action.payload.selected = !action.payload.selected;
            let selectedProjectPrioritys = 0;
            const projectPriorityList = state.projectPriorityList.map((projectPriority) => {
                if (projectPriority.selected) {
                    selectedProjectPrioritys++;
                }
                if (projectPriority.id === action.payload.id) {
                    if (projectPriority.selected) {
                        selectedProjectPrioritys++;
                    }
                    return action.payload;
                } else {
                    return projectPriority;
                }
            });
            return {
                ...state,
                INIT_STATE,
                selectedProjectPrioritys: selectedProjectPrioritys,
                projectPriorityList: projectPriorityList,
            };
        }
        case ON_ADD_PROJECT_PRIORITY: {
            return { ...state, addProjectPriorityState: true };
        }
        case ON_PROJECT_PRIORITY_CLOSE: {
            return { ...state, addProjectPriorityState: false };
        }
        case ON_FILTER_PROJECT_PRIORITY_OPTION_SELECT: {
            let selectedSectionId = 0;
            let filterOption = '';
            let projectPriorityList = [];
            switch (action.payload.name) {
                case ALL_FILTER: {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    projectPriorityList = state.allProjectPriority;
                    break;
                }
                case STARRED_FILTER: {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    projectPriorityList = state.allProjectPriority.filter((projectPriority) => projectPriority.starred);
                    break;
                }
            }
            return {
                ...state,
                selectedSectionId,
                filterOption,
                projectPriorityList,
                drawerState: false,
            };
        }
        case ON_SAVE_PROJECT_PRIORITY_SUCCESS: {
            return {
                ...state,
                alertMessage: 'Project Priority Updated Successfully',
                showMessage: true,
                projectPriorityList: action.payload,
                allProjectPriority: action.payload,
                loader: false,
            };
        }
        case ON_DELETE_PROJECT_PRIORITY_SUCCESS: {
            return {
                ...state,
                alertMessage: 'Project Priority Filtered Successfully',
                showMessage: true,
                allProjectPriority: state.allProjectPriority.filter((projectPriority) => projectPriority.id !== action.payload.id),
                projectPriorityList: state.allProjectPriority.filter((projectPriority) => projectPriority.id !== action.payload.id),
                loader: false,
            };
        }
        case ON_DELETE_SELECTED_PROJECT_PRIORITY: {
            const projectPrioritys = state.allProjectPriority.filter((projectPriority) => !projectPriority.selected);
            return {
                ...state,
                alertMessage: 'Project Priority Deleted Successfully',
                showMessage: true,
                allProjectPriority: projectPrioritys,
                projectPriorityList: projectPrioritys,
                selectedProjectPrioritys: 0,
            };
        }
        case FILTER_PROJECT_PRIORITY: {
            const { filterOption } = state;
            let projectPriorityList = [];
            if (action.payload === '') {
                projectPriorityList = state.allProjectPriority;
            } else {
                const filterProjectPriority = state.allProjectPriority.filter((projectPriority) => projectPriority.name.toLowerCase().indexOf(action.payload.toLowerCase()) > -1);
                if (filterOption === ALL_FILTER) {
                    projectPriorityList = filterProjectPriority;
                } else if (filterOption === STARRED_FILTER) {
                    projectPriorityList = filterProjectPriority.filter((project) => project.starred);
                }
            }
            return { ...state, projectPriorityList: projectPriorityList };
        }
        case GET_ALL_PROJECT_PRIORITY: {
            let projectPriorityList = state.allProjectPriority.map((projectPriority) =>
                projectPriority
                    ? {
                          ...projectPriority,
                          selected: true,
                      }
                    : projectPriority
            );
            return {
                ...state,
                selectedProjectPrioritys: projectPriorityList.length,
                allProjectPriority: projectPriorityList,
                projectPriorityList: projectPriorityList,
            };
        }
        case GET_UNSELECTED_ALL_PROJECT_PRIORITY: {
            let projectPriorityList = state.allProjectPriority.map((projectPriority) =>
                projectPriority
                    ? {
                          ...projectPriority,
                          selected: false,
                      }
                    : projectPriority
            );
            return {
                ...state,
                selectedProjectPrioritys: 0,
                allProjectPriority: projectPriorityList,
                projectPriorityList: projectPriorityList,
            };
        }
        case ON_ALL_PROJECT_PRIORITY_SELECT: {
            const selectAll = state.selectedProjectPrioritys < state.projectPriorityList.length;
            let selectedProjectPrioritys = 0;
            let projectPriorityList = [];
            if (selectAll) {
                projectPriorityList = state.allProjectPriority.map((projectPriority) =>
                    projectPriority
                        ? {
                              ...projectPriority,
                              selected: true,
                          }
                        : projectPriority
                );
                selectedProjectPrioritys = projectPriorityList.length;
            } else {
                projectPriorityList = state.allProjectPriority.map((projectPriority) =>
                    projectPriority
                        ? {
                              ...projectPriority,
                              selected: true,
                          }
                        : projectPriority
                );
                selectedProjectPrioritys = 0;
            }
            return {
                ...state,
                selectedProjectPrioritys: selectedProjectPrioritys,
                allProjectPriority: projectPriorityList,
                projectPriorityList: projectPriorityList,
            };
        }
        case UPDATE_SEARCH_PROJECT_PRIORITY: {
            return { ...state, searchProjectPriority: action.payload };
        }
        case HANDLE_PROJECT_PRIORITY_REQUEST_CLOSE: {
            return { ...state, showMessage: false };
        }
        case ON_TOGGLE_PROJECT_PRIORITY_DRAWER: {
            return { ...state, drawerState: !state.drawerState };
        }
        case SHOW_PROJECT_PRIORITY_LOADER: {
            return { ...state, loader: true };
        }
        case HIDE_PROJECT_PRIORITY_LOADER: {
            return { ...state, loader: false };
        }

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./reducers/projectPriority.js